import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { HighlightOff } from '@mui/icons-material';
import NotificationRowContent from 'components/notifications/NotificationRowContent';

function PlanRequestRejectedNotification({ notification }) {
  const { t } = useTranslation(['notifications']);
  const { plan, rejection_reason: rejectionReason } = notification.data;

  // El motivo se concatena al cuerpo: la fila muestra dos líneas y un bloque aparte se
  // cortaría de todos modos.
  const reason = rejectionReason
    ? ` ${t('planRequest.rejectedNotification.reason', { ns: 'notifications' })}: ${rejectionReason}`
    : '';

  return (
    <NotificationRowContent
      notification={notification}
      icon={HighlightOff}
      title={t('planRequest.rejectedNotification.title', { ns: 'notifications' })}
      body={`${t('planRequest.rejectedNotification.body', {
        name: plan?.name,
        ns: 'notifications'
      })}${reason}`}
    />
  );
}

PlanRequestRejectedNotification.propTypes = {
  notification: PropTypes.shape({
    created_at: PropTypes.string.isRequired,
    data: PropTypes.shape({
      plan: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      }),
      rejection_reason: PropTypes.string
    }).isRequired,
    id: PropTypes.string.isRequired,
    read: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired
};

export default PlanRequestRejectedNotification;
